<!-- @veltra/icons generated sha256:41617f568a8a3953 gen:8 source:src/svg/normal/dot.svg -->
<script setup lang="ts">
defineOptions({ name: 'Dot' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="2" fill="currentColor" />
  </svg>
</template>
